import { Modal } from "antd";
import PropTypes from "prop-types";

/**
 * @author traj3ctory
 * @function LoginLoading
 **/

const LoginLoading = ({ showModal }) => {
  return (
    <Modal
      title="Logging in"
      centered
      open={showModal}
      footer={null}
      className="loading_modal"
      closable={false}
    >
      <div className="login_modal_container">
        <div className="spinner-circle">
          <div className="spinner" />
        </div>
        <p>Please wait...</p>
      </div>
    </Modal>
  );
};

LoginLoading.propTypes = {
  showModal: PropTypes.bool,
};

export default LoginLoading;
